import { clDebug, initOnScroll, pollFor } from './utils/utils';
import { populatePriceTemplate, populateLineItemTemplate, populateCartTotals } from './rendering';
import {
  getRequestBody,
  getPricesAndPopulate,
  createDraftOrder,
  getCartPromotionsAndPopulate,
  getFidelityCouponsAndPopulate,
} from './apiCalls';
import {
  getCouponsFromLocalStorage,
  initCouponsForm,
  initRemoveCoupon,
  populateCouponFeedback,
  removeAllCouponsFromLocalStorage,
} from './coupons';
import {
  getFidelityCouponFromLocalStorage,
  initFidelityCouponForm,
  removeFidelityFromLocalStorage,
} from './fidelity';

// --- GENERIC NAMES FOR CLASSES AND ATTRIBUTES ---
const PRICE_CHANGED_CLASS = 'vp-price-changed';

// SELECTORS
const ID_DATA_ATTR = 'data-vp-id';
const QTY_DATA_ATTR = 'data-vp-qty';
const SELECTOR_WITH_ID = `[${ID_DATA_ATTR}]:not(.${PRICE_CHANGED_CLASS})`;

// ------------------------------------------------

/**
 * Initialise VP on IDs
 */
export function runVPOnIds(shopName, moneyFormat) {
  // STEP 1
  pollFor(SELECTOR_WITH_ID, run);

  // STEP 2
  function run($e) {
    const $products = !$e || !$e.length ? $(SELECTOR_WITH_ID) : $e;

    // First prices transformation
    getProductPrices($products);

    // After scrolling, second prices transformation
    initOnScroll(() => {
      getProductPrices($(SELECTOR_WITH_ID));
    });
  }

  // STEP 3
  function getProductPrices($products) {
    const productVariants = [];
    const lineItems = [];

    $products.each((_i, product) => {
      try {
        const $product = $(product);
        $product.addClass(PRICE_CHANGED_CLASS);
        const productVariant = $product.attr(ID_DATA_ATTR);

        if (productVariant) {
          const quantity = Number($product.attr(QTY_DATA_ATTR));
          if (quantity !== undefined) productVariants.push(productVariant);
          if (
            quantity > 0 &&
            !lineItems.find(
              (lineItem) =>
                lineItem.variant_id === productVariant && lineItem.quantity === quantity,
            )
          )
            lineItems.push({ variant_id: productVariant, quantity: quantity });
        }
      } catch (error) {}
    });

    if (productVariants.length) {
      getPricesAndPopulate(populatePrices, shopName, productVariants, false);
    }
    if (lineItems.length) {
      const couponsLocalStorage = getCouponsFromLocalStorage();
      const fidelityCouponLocalStorage = getFidelityCouponFromLocalStorage();
      clDebug(`*** (getProductPrices) :: couponsLocalStorage: ${couponsLocalStorage}`);
      clDebug(
        `*** (getProductPrices) :: fidelityCouponLocalStorage: ${fidelityCouponLocalStorage}`,
      );
      initCouponsForm(populateCartPromotions, shopName, lineItems);
      getFidelityCouponsAndPopulate((data) => {
        initFidelityCouponForm(data, populateCartPromotions, shopName, lineItems);
      }, shopName);
      initDraftOrder(lineItems);
      getCartPromotionsAndPopulate(
        populateCartPromotions,
        shopName,
        lineItems,
        couponsLocalStorage,
        fidelityCouponLocalStorage,
      );
    }
  }

  function populateCartPromotions(data) {
    const apiLineItems = data.line_items;
    const apiCart = data.cart;
    const apiConsumedCoupons = data.consumed_coupons;
    const apiCoupons = data.coupon;

    if (!apiLineItems || !apiCart) {
      return;
    }

    // Populate coupon feedback
    populateCouponFeedback(apiConsumedCoupons, apiCoupons);

    // Line items
    apiLineItems.forEach(
      ({
        variant_id,
        quantity,
        line_compare_at_price,
        compare_at_price,
        original_line_price,
        original_price,
        final_line_price,
        final_price,
      }) => {
        const $lineItems = $(`[${QTY_DATA_ATTR}][${ID_DATA_ATTR}="${variant_id}"]`);
        $lineItems.each(function () {
          const $lineItem = $(this);
          populateLineItemTemplate(
            $lineItem,
            line_compare_at_price,
            compare_at_price,
            final_line_price,
            final_price,
            moneyFormat,
            apiLineItems,
            variant_id,
          );
        });
      },
    );

    // Cart summary
    populateCartTotals(apiCart, apiConsumedCoupons, moneyFormat);

    // Coupons
    initRemoveCoupon();
  }

  // STEP 4
  function populatePrices(data) {
    const productPrices = data.variants_prices;
    if (!productPrices) {
      return;
    }
    productPrices.forEach(({ compare_at_price, price, variant_id }) => {
      const $products = $(`[${ID_DATA_ATTR}="${variant_id}"]`);
      $products.each(function () {
        const $product = $(this);
        if ($product.attr(QTY_DATA_ATTR) === undefined)
          populatePriceTemplate($product, compare_at_price, price, moneyFormat);
      });
    });
  }

  /**
   * Initialise draft order (when user goes to checkout)
   * On cart page and mini cart
   */
  function initDraftOrder(lineItems) {
    pollFor('.vp-checkout-btn', ($submitBtn) => {
      $submitBtn.off('click').on('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const couponsLocalStorage = getCouponsFromLocalStorage();
        removeAllCouponsFromLocalStorage();
        const fidelityCouponLocalStorage = getFidelityCouponFromLocalStorage();
        removeFidelityFromLocalStorage();
        const body = getRequestBody(
          lineItems,
          false,
          false,
          true,
          couponsLocalStorage,
          fidelityCouponLocalStorage,
        );
        createDraftOrder(body, shopName, ({ location }) => {
          if (location) {
            const locale = window.__ozjs?.privateSales?.language?.locale;
            const locationWithLocale = location + '?locale=' + locale;
            const url = locale ? locationWithLocale : location;
            window.location.href = url;
          }
        });
      });
    });
  }
}
